import type { EchoflicksSessionMedia } from "../types";
import { isVideo } from "./sessionUtils";

export function isGalleryVideo(media: EchoflicksSessionMedia): boolean {
  if (isVideo(media.mime_type)) return true;
  const path =
    media.storage_path ?? media.s3_key ?? media.local_path ?? media.url ?? "";
  return /\.(mp4|m4v|mov|webm)(?:$|[?#])/i.test(path);
}

export function galleryCaption(media: EchoflicksSessionMedia): string | null {
  const caption = media.gemini_caption?.trim();
  if (!caption) return null;
  const match = caption.match(/^\S+\s*[\u2013-]\s*([\s\S]*)$/);
  return match ? match[1].trim() : caption;
}
